var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Icon, RadioButtons, TextBox, useModal, } from "@animech/ui";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { maxBy } from "lodash";
import * as Styled from "./save-pallet-layout-modal.style";
import { actions, selectors, useAppDispatch, useAppSelector } from "store";
import { CustomConfirmModal } from "ui/components/modals/custom-confirm-modal/custom-confirm-modal";
import { LoadingModal } from "ui/components/modals/loading-modal/loading-modal";
import { Dropdown } from "ui/components/elements/input/dropdown";
import { PalletLayoutIcon } from "ui/components/panels/canvas/pallet-preset-switch/pallet-layout-icon";
var SaveMode;
(function (SaveMode) {
    SaveMode["NEW"] = "new";
    SaveMode["OVERWRITE"] = "overwrite";
})(SaveMode || (SaveMode = {}));
var translationPrefix = "save_pallet_layout_modal";
var content = (_a = {},
    _a[SaveMode.NEW] = {
        label: "".concat(translationPrefix, ".radio_button_new"),
        okActionLabel: "".concat(translationPrefix, ".confirm_button_new"),
        icon: "copy",
    },
    _a[SaveMode.OVERWRITE] = {
        label: "".concat(translationPrefix, ".radio_button_overwrite"),
        okActionLabel: "".concat(translationPrefix, ".confirm_button_overwrite"),
        icon: "save",
    },
    _a);
var modes = Object.values(SaveMode);
/*
 * Names the layer being worked on and saves it to the user's library, either
 * as a new saved layer or over one already there. A layer laid out from (or
 * last saved as) a saved one starts out overwriting that one; otherwise saving
 * starts out as new, and overwriting from the most recently saved layer. The
 * name follows whichever one is picked to overwrite, so it can be kept or
 * changed. Overwriting shows what is replaced by what, since the default can
 * be it.
 */
export var SavePalletLayoutModal = function (_a) {
    var _b;
    var props = __rest(_a, []);
    var onShouldClose = props.onShouldClose;
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var openModal = useModal();
    var savedLayouts = useAppSelector(selectors.selectSavedPalletLayouts);
    var layoutInUse = useAppSelector(selectors.selectSavedPalletLayoutInUse);
    var currentLayout = useAppSelector(selectors.selectActiveLayerPalletLayout);
    var initiallyOverwritten = layoutInUse !== null && layoutInUse !== void 0 ? layoutInUse : maxBy(savedLayouts, function (savedLayout) { return Date.parse(savedLayout.lastEdited); });
    var _c = __read(useState(layoutInUse ? SaveMode.OVERWRITE : SaveMode.NEW), 2), saveMode = _c[0], setSaveMode = _c[1];
    var _d = __read(useState(initiallyOverwritten === null || initiallyOverwritten === void 0 ? void 0 : initiallyOverwritten.id), 2), overwriteId = _d[0], setOverwriteId = _d[1];
    var _e = __read(useState(""), 2), newName = _e[0], setNewName = _e[1];
    var _f = __read(useState((_b = initiallyOverwritten === null || initiallyOverwritten === void 0 ? void 0 : initiallyOverwritten.name) !== null && _b !== void 0 ? _b : ""), 2), overwriteName = _f[0], setOverwriteName = _f[1];
    var isOverwriting = saveMode === SaveMode.OVERWRITE;
    var name = isOverwriting ? overwriteName : newName;
    var setName = isOverwriting ? setOverwriteName : setNewName;
    var overwritten = isOverwriting
        ? savedLayouts.find(function (savedLayout) { return savedLayout.id === overwriteId; })
        : undefined;
    /* Allowed, but the list tells saved layers apart by name. */
    var isNameTaken = savedLayouts.some(function (savedLayout) {
        return savedLayout.id !== (overwritten === null || overwritten === void 0 ? void 0 : overwritten.id) &&
            savedLayout.name.trim().toLowerCase() === name.trim().toLowerCase();
    });
    var onPickOverwritten = useCallback(function (id) {
        var _a, _b;
        setOverwriteId(id);
        setOverwriteName((_b = (_a = savedLayouts.find(function (savedLayout) { return savedLayout.id === id; })) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "");
    }, [savedLayouts]);
    var onSave = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var loadingModal;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadingModal = openModal(_jsx(LoadingModal, { translationKey: "".concat(translationPrefix, ".loading_save") }));
                    return [4 /*yield*/, dispatch(actions.savePalletLayout(name, isOverwriting ? overwriteId : undefined))];
                case 1:
                    _a.sent();
                    loadingModal.close();
                    onShouldClose && onShouldClose(true);
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, isOverwriting, name, onShouldClose, openModal, overwriteId]);
    return (_jsx(CustomConfirmModal, __assign({ title: t("".concat(translationPrefix, ".title")), cancelActionLabel: t("modal.close"), okActionLabel: t(content[saveMode].okActionLabel), color: "inverted", cancelButtonProps: { color: "primary" }, confirmButtonProps: {
            color: "primary",
            onClick: onSave,
            disabled: name === "" || (isOverwriting && !overwritten),
        }, hideCloseButton: false }, props, { children: _jsxs(Styled.Container, { children: [savedLayouts.length > 0 && (_jsx(RadioButtons, { items: modes, itemLabels: modes.map(function (mode) { return t(content[mode].label); }), itemIcons: modes.map(function (mode) { return content[mode].icon; }), value: saveMode, color: "inverted", onValueChange: setSaveMode })), overwritten && (_jsxs(_Fragment, { children: [_jsx(Dropdown, { items: savedLayouts.map(function (_a) {
                                var id = _a.id;
                                return id;
                            }), itemLabels: savedLayouts.map(function (_a) {
                                var name = _a.name;
                                return name;
                            }), value: overwritten.id, onValueChange: onPickOverwritten, label: t("".concat(translationPrefix, ".overwrite_label")) }), _jsxs(Styled.OverwritePreview, { "data-testid": "overwrite-preview", children: [_jsxs(Styled.PreviewLayout, { children: [_jsx(PalletLayoutIcon, { layout: overwritten.layout, width: 88 }), t("".concat(translationPrefix, ".preview_saved"), {
                                            count: overwritten.layout.boxes.length,
                                        })] }), _jsx(Icon, { name: "arrow-right-regular" }), _jsxs(Styled.PreviewLayout, { children: [_jsx(PalletLayoutIcon, { layout: currentLayout, width: 88 }), t("".concat(translationPrefix, ".preview_current"), {
                                            count: currentLayout.boxes.length,
                                        })] })] }), _jsx(Styled.Note, { children: t("".concat(translationPrefix, ".overwrite_note"), {
                                name: overwritten.name,
                            }) })] })), _jsxs(Styled.TextFieldContainer, { children: [_jsx(TextBox, { value: name, label: t("".concat(translationPrefix, ".textbox_label")), onValueChange: setName, instantValueChange: true }), isNameTaken && (_jsx(Styled.Note, { "data-testid": "name-taken", children: t("".concat(translationPrefix, ".name_taken"), { name: name.trim() }) }))] })] }) })));
};
